<h1 mat-dialog-title>Sind Sie sicher?</h1>
<div mat-dialog-content>
  <p>Dieses Feature wird mit 15&nbsp;ct pro Beleg verrechnet.</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Nein, danke.</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Ja!</button>
</div>
